/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Line, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Lightbulb(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Line
        x1={88.00244}
        y1={232}
        x2={168.00244}
        y2={232}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M79.96926,167.98091A79.87808,79.87808,0,0,1,48.00369,104.4514c-.23961-43.36225,34.71874-79.40834,78.06972-80.42868a80.00431,80.00431,0,0,1,49.774,144.09929,19.791,19.791,0,0,0-7.84468,15.87805v.00023a8,8,0,0,1-8,7.99971H96.00212a8,8,0,0,1-8-7.99967v-.22676A19.80385,19.80385,0,0,0,79.96926,167.98091Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M163.11025,95.99939a36.05137,36.05137,0,0,0-27.10744-27.10724"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default Lightbulb;
